// import React from 'react';
// import styled from 'styled-components';

// const PageContainer = styled.div`
//     padding: 100px 20px;
//     max-width: 1200px;
//     margin: 0 auto;
// `;

// const HeroSection = styled.section`
//     text-align: center;
//     margin-bottom: 60px;
// `;

// const Title = styled.h1`
//     font-size: 3rem;
//     color: #333;
//     margin-bottom: 20px;
// `;

// const Subtitle = styled.p`
//     font-size: 1.2rem;
//     color: #666;
//     max-width: 800px;
//     margin: 0 auto;
// `;

// const ContentSection = styled.section`
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 40px;
//     margin-top: 40px;

//     @media (max-width: 768px) {
//         grid-template-columns: 1fr;
//     }
// `;

// const FeatureCard = styled.div`
//     background: #fff;
//     padding: 30px;
//     border-radius: 10px;
//     box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//     transition: transform 0.3s ease;

//     &:hover {
//         transform: translateY(-5px);
//     }
// `;

// const FeatureTitle = styled.h2`
//     color: #1a2a6c;
//     margin-bottom: 15px;
//     font-size: 1.8rem;
// `;

// const FeatureDescription = styled.p`
//     color: #666;
//     line-height: 1.6;
//     margin-bottom: 20px;
// `;

// const TechStack = styled.div`
//     margin-top: 20px;
// `;

// const TechTitle = styled.h3`
//     color: #1a2a6c;
//     margin-bottom: 10px;
//     font-size: 1.2rem;
// `;

// const TechList = styled.div`
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
// `;

// const TechItem = styled.span`
//     background: #f0f2f5;
//     padding: 8px 16px;
//     border-radius: 20px;
//     color: #1a2a6c;
//     font-size: 0.9rem;
// `;

// const WebDevelopment = () => {
//     return (
//         <PageContainer>
//             <HeroSection>
//                 <Title>Web Development Services</Title>
//                 <Subtitle>
//                     Create powerful, scalable, and beautiful web applications with modern technologies
//                     and best practices.
//                 </Subtitle>
//             </HeroSection>

//             <ContentSection>
//                 <FeatureCard>
//                     <FeatureTitle>Frontend Development</FeatureTitle>
//                     <FeatureDescription>
//                         We create responsive and interactive user interfaces that provide an exceptional
//                         user experience across all devices.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Technologies We Use:</TechTitle>
//                         <TechList>
//                             <TechItem>React</TechItem>
//                             <TechItem>Vue.js</TechItem>
//                             <TechItem>Angular</TechItem>
//                             <TechItem>HTML5</TechItem>
//                             <TechItem>CSS3</TechItem>
//                             <TechItem>JavaScript</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Backend Development</FeatureTitle>
//                     <FeatureDescription>
//                         Robust and secure server-side solutions that power your applications with
//                         reliable performance and scalability.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Technologies We Use:</TechTitle>
//                         <TechList>
//                             <TechItem>Node.js</TechItem>
//                             <TechItem>Python</TechItem>
//                             <TechItem>Java</TechItem>
//                             <TechItem>PHP</TechItem>
//                             <TechItem>MongoDB</TechItem>
//                             <TechItem>PostgreSQL</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>E-Commerce Solutions</FeatureTitle>
//                     <FeatureDescription>
//                         Build powerful online stores with secure payment processing, inventory
//                         management, and customer relationship tools.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Platforms We Work With:</TechTitle>
//                         <TechList>
//                             <TechItem>Shopify</TechItem>
//                             <TechItem>WooCommerce</TechItem>
//                             <TechItem>Magento</TechItem>
//                             <TechItem>Custom Solutions</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Web Optimization</FeatureTitle>
//                     <FeatureDescription>
//                         Optimize your web applications for maximum performance, SEO, and conversion
//                         rates.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Our Focus Areas:</TechTitle>
//                         <TechList>
//                             <TechItem>SEO</TechItem>
//                             <TechItem>Performance</TechItem>
//                             <TechItem>Security</TechItem>
//                             <TechItem>Analytics</TechItem>
//                             <TechItem>Mobile-First</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>
//             </ContentSection>
//         </PageContainer>
//     );
// };

// export default WebDevelopment; 



import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaCode, 
  FaServer, 
  FaShoppingCart, 
  FaRocket, 
  FaReact, 
  FaVuejs, 
  FaAngular,
  FaNodeJs,
  FaPython,
  FaJava,
  FaPhp,
  FaDatabase,
  FaShopify,
  FaWordpress,
  FaSearch,
  FaShieldAlt,
  FaChartLine,
  FaMobileAlt
} from 'react-icons/fa';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

// Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  border-radius: 24px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px var(--theme-shadow-accent);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
    background-blend-mode: overlay;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  
  span {
    display: block;
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #FFC857;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
`;

const ContentSection = styled(motion.section)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const FeatureCard = styled(motion.div)`
  background: #ffffff;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border-top: 4px solid var(--theme-accent);
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .feature-icon {
      transform: scale(1.1);
      color: var(--theme-accent);
      animation: ${float} 3s ease-in-out infinite;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 35px 25px;
  }
`;

const FeatureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  transition: all 0.4s ease;
  flex-shrink: 0;

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const FeatureTitle = styled.h2`
  color: var(--theme-primary);
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

const FeatureDescription = styled.p`
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 1.05rem;
  font-weight: 400;
`;

const TechStack = styled.div`
  margin-top: 25px;
`;

const TechTitle = styled.h3`
  color: var(--theme-primary);
  margin-bottom: 15px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TechList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const TechItem = styled(motion.span)`
  background: var(--theme-surface-muted);
  color: var(--theme-primary);
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  border: 1px solid var(--theme-border);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: var(--theme-accent-soft);
    color: var(--theme-accent);
    border-color: var(--theme-accent-soft);
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    padding: 8px 14px;
    font-size: 0.85rem;
  }
`;

const ProcessSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
  border-radius: 24px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #FFFFFF;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

const ProcessGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const ProcessStep = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 30px 25px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-5px);
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
  }
`;

const StepNumber = styled.div`
  width: 50px;
  height: 50px;
  background: #FFC857;
  color: var(--theme-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 800;
  margin: 0 auto 20px;
`;

const StepTitle = styled.h3`
  color: #FFC857;
  margin-bottom: 15px;
  font-size: 1.3rem;
  font-weight: 600;
`;

const StepDescription = styled.p`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 1rem;
`;

const CTAButton = styled(motion.a)`
  background: linear-gradient(135deg, #FFC857, #FF9F1C);
  color: var(--theme-primary);
  padding: 1.2rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 25px rgba(255, 200, 87, 0.3),
    inset 0 1px 0 rgba(255,255,255,0.3);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-top: 50px;
  letter-spacing: 0.5px;
  border: none;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 12px 30px rgba(255, 200, 87, 0.4),
      inset 0 1px 0 rgba(255,255,255,0.3);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-top: 40px;
  }
`;

const StatsSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const StatItem = styled(motion.div)`
  text-align: center;
  
  .stat-number {
    font-size: 3rem;
    font-weight: 800;
    color: var(--theme-accent);
    margin-bottom: 10px;
    display: block;
    line-height: 1;
  }
  
  .stat-label {
    font-size: 1.1rem;
    color: #64748b;
    font-weight: 600;
  }
`;

const WebDevelopment = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    Web Development Services
                    <span>Modern & Scalable Solutions</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    Create powerful, scalable, and beautiful web applications with modern technologies
                    and best practices. We deliver exceptional digital experiences that drive business growth.
                </Subtitle>
            </HeroSection>

            <ContentSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaCode />
                        </FeatureIcon>
                        <FeatureTitle>Frontend Development</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        We create responsive and interactive user interfaces that provide an exceptional
                        user experience across all devices and browsers. Our frontend solutions are
                        performant, accessible, and visually stunning.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaCode />
                            Technologies We Use
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaReact /> React
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaVuejs /> Vue.js
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaAngular /> Angular
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                HTML5
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                CSS3
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                TypeScript
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaServer />
                        </FeatureIcon>
                        <FeatureTitle>Backend Development</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Robust and secure server-side solutions that power your applications with
                        reliable performance and scalability. We build APIs, databases, and server
                        infrastructure that can handle millions of requests.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaServer />
                            Technologies We Use
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaNodeJs /> Node.js
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaPython /> Python
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaJava /> Java
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaPhp /> PHP
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaDatabase /> MongoDB
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaDatabase /> PostgreSQL
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaShoppingCart />
                        </FeatureIcon>
                        <FeatureTitle>E-Commerce Solutions</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Build powerful online stores with secure payment processing, inventory
                        management, and customer relationship tools. We create e-commerce platforms
                        that convert visitors into loyal customers.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaShoppingCart />
                            Platforms We Work With
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaShopify /> Shopify
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaWordpress /> WooCommerce
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Magento
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Custom Solutions
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaRocket />
                        </FeatureIcon>
                        <FeatureTitle>Web Optimization</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Optimize your web applications for maximum performance, SEO, and conversion
                        rates. We ensure your website loads quickly, ranks well, and provides
                        an exceptional user experience.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaRocket />
                            Our Focus Areas
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaSearch /> SEO
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Performance
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaShieldAlt /> Security
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaChartLine /> Analytics
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaMobileAlt /> Mobile-First
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>
            </ContentSection>

            <StatsSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle style={{ color: 'var(--theme-primary)' }} variants={itemVariants}>
                    Our Web Development Impact
                </SectionTitle>
                <StatsGrid>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">200+</span>
                        <div className="stat-label">Websites Built</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">99.9%</span>
                        <div className="stat-label">Uptime Guarantee</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">50%</span>
                        <div className="stat-label">Faster Load Times</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">100%</span>
                        <div className="stat-label">Client Satisfaction</div>
                    </StatItem>
                </StatsGrid>
            </StatsSection>

            <ProcessSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle variants={itemVariants}>
                    Our Development Process
                </SectionTitle>
                <ProcessGrid>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>1</StepNumber>
                        <StepTitle>Discovery & Planning</StepTitle>
                        <StepDescription>
                            We analyze your requirements, define project scope, and create a detailed
                            development roadmap with clear milestones.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>2</StepNumber>
                        <StepTitle>Design & Prototyping</StepTitle>
                        <StepDescription>
                            Create intuitive user interfaces and interactive prototypes that bring
                            your vision to life before development begins.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>3</StepNumber>
                        <StepTitle>Development</StepTitle>
                        <StepDescription>
                            Agile development process with regular updates, code reviews, and
                            quality assurance at every stage.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>4</StepNumber>
                        <StepTitle>Launch & Support</StepTitle>
                        <StepDescription>
                            Smooth deployment, thorough testing, and ongoing maintenance to ensure
                            your web application runs perfectly.
                        </StepDescription>
                    </ProcessStep>
                </ProcessGrid>
                
                <CTAButton 
                    href="/contact"
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Start Your Web Project
                    <FaRocket />
                </CTAButton>
            </ProcessSection>
        </PageContainer>
    );
};

export default WebDevelopment;
